<template>
	<div>
		<sBox title="Grade de Tipos de clientes">
			<div slot="tools">
				<aBtn
					action="private-save-typeOfClients"
					text="T/Clientes"
					icon="plus"
					size="sm"
					type="success"
					@click="(data) => $refs.mdl.open()"
				/>
			</div>
			<div slot="body">
				<br />
				<div class="row">
					<div class="pull-right col-sm-12">
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-search"></i>
							</span>
							<input
								type="text"
								@input="filter($event.target.value)"
								placeholder="Pesquisar"
								class="form-control"
							/>
						</div>
					</div>
				</div>
				<br />
				<sTable
					ref="tab1"
					actionRead="private-read-typeOfClients"
					actionDelete="private-delete-typeOfClients"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.mdl.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="mdl" @update="$refs.tab1.updateTable()" />
	</div>
</template>
<script>
	import sBox from 'box';
	import sTable from 'table';
	import aBtn from 'btn';
	import modal from './modal.tipo.cliente.vue';
	import pad from 'js/pad';

	export default {
		name: 'TiposDeClientes',
		components: { sBox, sTable, aBtn, modal },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'title', label: 'Titulo' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 3);
						},
					},
				],
			};
		},
		methods: {
			filter(data) {
				if (data != '') {
					this.$refs.tab.setFilter(`
							cod like '%${data}%' or 
							title like '%${data}%'  
					`);
				} else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/regions/tipos.de.cliente.vue